import React from "react";
import Individual from "./Individual";
import Entity from "./Entity";
import { NavLink, Route, Switch } from 'react-router-dom';
import {whereBallsMove} from "../../helper";

class SignUp extends React.Component {
    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(5)
    }

    render() {
        return (
            <div className="vertical-scrolling page fifthSection sectionSignUp" id="sectionSignUp" data-main-nav-id="signUpNavLink">
                <div className="container content">
    
                    <div className="left-content left-content-width sign-up-left" style={{justifyContent: "start"}}>
                        <div className="login-top">
                            <h2 style={{marginTop: "0"}}>Регистрация</h2>
                            <ul className="menu-content-nav">
                                <NavLink exact to="/signup">
                                    Как физическое лицо
                                </NavLink>
                                <NavLink to="/signup/entity">
                                    Как юридическое лицо
                                </NavLink>
                            </ul>
                        </div>
                    </div>
    
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <Switch>
                                <Route exact path="/signup" component={Individual} />
                                <Route path="/signup/entity" component={Entity} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SignUp;


// WEBPACK FOOTER //
// ./src/components/SignUp/index.js